import script from "./MinhaAssinaturaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MinhaAssinaturaPage.vue?vue&type=script&setup=true&lang=js"

import "./MinhaAssinaturaPage.vue?vue&type=style&index=0&id=253a4ddd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-253a4ddd"]])

export default __exports__